import { useMutation, useQuery } from '@tanstack/react-query';
import apiClient from '@/lib/api/apiClient';
import {
  ListPsisResponse,
  RequestPsiContactResponse,
  GetPsiProfileResponse,
} from '@inversor-hub/types';
import { AxiosResponse } from 'axios';

export function useListPsis(provinces: string[]) {
  return useQuery({
    queryKey: ['psis', provinces],
    queryFn: async () =>
      apiClient.get<ListPsisResponse>('/psis', {
        params: { provinces: provinces.join(',') },
      }),
    select: (response) => response.data.data,
    enabled: true,
  });
}

export function useGetPsiProfile(psiId: string) {
  return useQuery({
    queryKey: ['psi-profile', psiId],
    queryFn: async () => apiClient.get<GetPsiProfileResponse>(`/psis/${psiId}`),
    select: (response) => response.data.data,
    enabled: !!psiId,
  });
}

export function useRequestPsiContact() {
  return useMutation({
    mutationFn: async (psiId: string) => {
      const response = await apiClient.post<unknown, AxiosResponse<RequestPsiContactResponse>>(
        `/psis/${psiId}/contact-requests`
      );
      return response.data.data;
    },
  });
}
